import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    width: '100%',
  },

  pool: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),

    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(1.5),
    },
  },

  rightContent: {
    textAlign: 'right',

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
  },

  imageContainer: {
    width: 30,
    minWidth: 30,
    height: 30,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },

  smallIcon: {
    width: 16,
    height: 16,
    minWidth: 16,
  },

  image: {
    objectFit: 'cover',
    width: '100%',
  },

  labels: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    color: alpha(theme.palette.text.primary, 0.6),
  },

  circle: {
    width: 2,
    height: 2,
    borderRadius: '50%',
    backgroundColor: alpha(theme.palette.text.primary, 0.6),
  },
}));
